import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/auth/session.service';
import { CommonNavigationsService } from 'src/app/shared/common-navigations.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html'
})
export class NavbarComponent implements OnInit {

  constructor(
    private sessionService: SessionService,
    private commonNavigations: CommonNavigationsService
  ) { }

  ngOnInit(): void {
  }

  signout() {
    this.sessionService.logout();
    this.commonNavigations.navigateToLogin();
  }

}
